export const EFFORT_OPTIONS = [
  "None",
  "Low",
  "Medium",
  "High",
  "Extra high",
  "Max",
];

export const PROVIDER_OPTIONS = ["openai", "anthropic", "gemini", "xai", "dochat"];

export const FAST_MODE_OPTIONS = ["Off", "On"];

const PROVIDER_LABELS = {
  openai: "OpenAI",
  anthropic: "Anthropic",
  gemini: "Google",
  xai: "xAI",
  dochat: "DO Chat",
};

export function providerLabel(provider) {
  const key = String(provider || "").toLowerCase().replace(/\s+/g, "");
  return PROVIDER_LABELS[key] ?? String(provider || "Other");
}

export function modelCost(model) {
  return "$".repeat(
    Math.max(1, Number(model?.costTier ?? model?.cost_tier ?? 1)),
  );
}
